import React, {useEffect, useState} from "react";
import {DATES, TimeNavbarPicker} from "@leap4/frontend"
import {DateTime} from "luxon"
import moment from "moment"

export interface ITimeNavbarPickerWrapperProps {
    dates: { startDate: string, endDate: string }
    setDates: (startDate: string, endDate: string) => void
    isLoading: boolean,
    toSkipDiscrepancy: boolean
}

export const TimeNavbarPickerWrapper = (props: ITimeNavbarPickerWrapperProps) => {
    const excludedTabs = props.toSkipDiscrepancy? [] : [DATES.TODAY, DATES.YESTERDAY]
    const {isLoading, setDates, dates, toSkipDiscrepancy} = props
    const luxonDate = DateTime.fromJSDate(new Date()).toUTC()
    const getLastAvailableDate = (toSkipDiscrepancy:boolean) =>{
        if(toSkipDiscrepancy) return null
        const momentDate = moment(new Date)
        const lastAvailableDay = momentDate.hour() <= 17 ? momentDate.subtract(2, 'days').toDate().toString() : momentDate.subtract(1, 'days').toDate().toString()
        return lastAvailableDay
    }
    const [lastAvailableDay, setLastAvailableDay] = useState(getLastAvailableDate(toSkipDiscrepancy))

    useEffect(()=>{
        setLastAvailableDay(getLastAvailableDate(toSkipDiscrepancy))
    },[toSkipDiscrepancy])

    const disableDates = (date) => {
        if(toSkipDiscrepancy){
            return false
        }
        if (luxonDate.toLocaleString() === DateTime.fromJSDate(new Date(date)).toLocaleString()) {
            return true
        }
        if (luxonDate.hour <= 17) {
            if (luxonDate.minus({day: 1}).toLocaleString() === DateTime.fromJSDate(new Date(date)).toLocaleString()) {
                return true
            }
        }
        return false;
    }



    return (
        <TimeNavbarPicker isLoading={isLoading}
                          excludeTabs={excludedTabs}
                          setDates={setDates} dates={dates}
                          disableEndDate={disableDates}
                          disableStartDate={disableDates}
                          lastAvailableDate={lastAvailableDay}/>
    );
}
